import { render, staticRenderFns } from "./CustomerItemsPermalink.vue?vue&type=template&id=4a0dfe62"
import script from "./CustomerItemsPermalink.vue?vue&type=script&lang=js"
export * from "./CustomerItemsPermalink.vue?vue&type=script&lang=js"
import style0 from "./CustomerItemsPermalink.vue?vue&type=style&index=0&id=4a0dfe62&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports